/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Skill_Groups_Modified_UtcInputs */

const en_tables_skill_groups_modified_utc = /** @type {(inputs: Tables_Skill_Groups_Modified_UtcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groups Modified UTC`)
};

const de_tables_skill_groups_modified_utc = /** @type {(inputs: Tables_Skill_Groups_Modified_UtcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geändert UTC`)
};

/**
* | output |
* | --- |
* | "Groups Modified UTC" |
*
* @param {Tables_Skill_Groups_Modified_UtcInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_skill_groups_modified_utc = /** @type {((inputs?: Tables_Skill_Groups_Modified_UtcInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Skill_Groups_Modified_UtcInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_skill_groups_modified_utc(inputs)
	return de_tables_skill_groups_modified_utc(inputs)
});